<template>
  <div class="options">
    <div class="options__buttons">
      <button
        v-for="(option, index) in options"
        :key="index"
        class="options__button"
        :class="{ active: getName === option.name }"
        @click="switchOption(option)"
      >
        {{ option?.name }}
      </button>
    </div>

    <search-input-vue @onSearch="handleSearch" />

    <h3 class="options__title">{{ $t('call_center.webphone.available') }} {{ getName }}</h3>

    <form
      ref="form"
      class="options__option"
    >
      <template v-if="getValues.length > 0">
        <render-option
          v-for="(option, index) in getValues"
          :key="index"
          :option="option"
          @onSelect="sendValue"
        />
      </template>

      <p
        v-else
        class="options__default-message"
      >
        {{ $t('call_center.webphone.no_result') }}
      </p>
    </form>
  </div>
</template>

<script>
  import { form } from '@bv/components';

  import SearchInputVue from '@/components/SharedComponents/Inputs/SearchInput.vue';

  import RenderOption from './RenderOption.vue';

  export default {
    name: 'AvailableOptions',
    components: {
      SearchInputVue,
      RenderOption,
    },
    props: {
      options: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        searchValue: '',
        selectedValue: null,
      };
    },
    computed: {
      getValues() {
        return (
          (this.selectedValue?.data || Object.values(this.options)[0]?.data || {}).filter((option) => {
            return option.name.toLocaleLowerCase().includes(this.searchValue.toLocaleLowerCase());
          }) || []
        );
      },
      getName() {
        return this.selectedValue?.name || Object.values(this.options)[0].name;
      },
    },
    methods: {
      switchOption(value) {
        this.selectedValue = value;
        this.sendValue(null);
        this.$refs.form.reset();
      },
      sendValue(value) {
        this.$emit('onSelect', value);
      },
      handleSearch(value) {
        this.searchValue = value;
        this.$emit('onSearch');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .options {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: hidden;
    width: 100%;
    gap: 16px;

    &__title {
      color: var(--gray900);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 16px;
      text-transform: capitalize;
    }

    &__buttons {
      display: flex;
      padding: 8px;
      align-items: center;
      gap: 8px;
      border-radius: 16px;
      border: 1px solid var(--gray100);
      background: var(--shadesWhite);
    }

    &__button {
      display: flex;
      height: 40px;
      padding: 8px 24px;
      justify-content: center;
      align-items: center;
      border-radius: var(--mainRadius);
      border: 1px solid var(--gray100);
      flex-grow: 1;

      &:hover,
      &.active {
        background: var(--color-base-500);
        color: var(--shadesWhite);
      }
    }

    &__option {
      display: flex;
      flex-direction: column;
      overflow-y: auto;
      flex: 1;
      width: 100%;
      gap: 16px;
      padding-inline-end: 4px;
    }

    &__default-message {
      text-align: center;
      color: var(--gray900);
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: 1;
      margin-bottom: 16px;
      text-transform: capitalize;
    }
  }
</style>
